import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { DuplicateOutgoingInvoice } from "@src/components/modules/invoices/Create/modules/DuplicateOutgoingInvoice";
import { NavigationOutgoingInvoice } from "@src/components/widgets/AppSubNav/navigation-invoices/outgoing-invoices";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Duplicate outgoing invoice`}
    navigation={<NavigationOutgoingInvoice invoiceId={id} />}
  >
    <DuplicateOutgoingInvoice id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/outgoing-invoices/duplicate")({
  component: RouteComponent,
});
